{
  "zh-TW": {
    "tools": {
      "descriptions": {
        "verseGuide": "全面的星際旅行指南，包含詳細的星系地圖、興趣點和星際公民宇宙中的探索路線",
        "starCitizenTools": "社群驅動的維基，包含有關飛船、武器、地點、遊戲機制和背景故事的詳細文檔",
        "starship42": "互動式3D飛船檢視器，包含詳細的外部和內部模型、組件佈局和尺寸比較",
        "erkul": "進階DPS計算器和飛船裝載優化器，包含詳細的武器統計數據和組件比較",
        "starjump": "2D艦隊視覺化工具，用於創建精美的飛船佈局和艦隊組織圖表",
        "itemFinder": "全面的物品和裝備位置資料庫，即時追蹤宇宙中的可用性",
        "starHangar": "可信賴的星際公民飛船承諾和包裹市場，提供安全交易和價格追蹤",
        "shinytracker": "個人進度追蹤器，用於任務、聲望、成就和探索目標，提供詳細統計數據",
        "uexCorp": "即時商品交易平台，包含價格追蹤、貿易路線優化和市場分析工具",
        "cargoGridViewer": "3D貨物網格檢視器，顯示所有飛船的貨艙尺寸和集裝箱適配情況",
        "scmdb": "瀏覽星際公民的任務、獎勵、聲望路徑、採礦資源等",
        "regolith": "星際公民採礦工具，提供岩石掃描、精煉計算和採礦頭比較",
        "spviewer": "Ship performance analysis tool with detailed flight characteristics, speed comparisons, and maneuverability data",
        "citizenId": "星際公民身份驗證和OAuth認證服務，為社群工具提供身份認證",
        "hauler": "星際公民貨運路線規劃和利潤計算工具"
      },
      "categories": {
        "trading": "貿易與經濟",
        "loadouts": "飛船裝載與戰鬥",
        "mining": "採礦",
        "guides": "資訊與指南",
        "missions": "任務與資料庫",
        "roadmap": "路線圖與追蹤",
        "fleet": "艦隊管理",
        "marketplace": "市場"
      },
      "discontinued": "該項目已停止維護。",
      "discontinuedHeading": "已停止的項目"
    }
  }
}
